import ReactCardFlip from "react-card-flip";
import React, { useEffect, useRef, useState } from "react";
import "./exploreandchange.scss";
import Buttons from "../../atoms/Buttons";
import Slider from "../../atoms/Range/Slider";
import { Col, OverlayTrigger, Popover, Row } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import { addCommas } from "../../helpers/helpers";
import cmsConfig from "../../redux/helpers/cmsConfig";

const ExploreAndChangeInvestment = (props) => {
  const [isFlipped, setIsFlipped] = useState({});
  const inputRef = useRef({});

  const [cardsData, setCardsData] = useState(
    props.data.filter((item) => item.fundType === props.category) //eslint-disable-line
  );

  useEffect(() => {
    setCardsData(props.data.filter((item) => item.fundType === props.category));
  }, []);

  const handleClick = (cardId) => {
    setIsFlipped((prevState) => ({
      ...prevState,
      [cardId]: !prevState[cardId],
    }));
  };

  const handleInputChange = (cardId, value) => {
    let fundPercentage = value.trimStart().replace(/\s+/g, "") || "0";
    if (fundPercentage !== "0") {
      fundPercentage = fundPercentage.replace(/^0+(?!\.)/, "");
    }
    const regex = /^(100|[1-9]?\d(\.\d{1,2})?|[1-9]?\d\.)$/;
    if (regex.test(fundPercentage) || fundPercentage === "") {
      setCardsData((prevCardsData) => {
        return prevCardsData.map((card) => {
          if (card.investmentId === cardId) {
            return {
              ...card,
              fundPercentage: fundPercentage,
              balance:
                fundPercentage !== ""
                  ? (
                      (parseFloat(props.totalFund) *
                        parseFloat(fundPercentage)) /
                      100
                    ).toFixed(2)
                  : 0,
            };
          }
          return card;
        });
      });
      props.onSliderChange(
        cardId,
        fundPercentage,
        fundPercentage !== ""
          ? (
              (parseFloat(props.totalFund) * parseFloat(fundPercentage)) /
              100
            ).toFixed(2)
          : 0 //eslint-disable-line
      );
    }
  };

  const handleKeyDown = (e, id) => {
    const inputIndex = cardsData?.findIndex((data) => data.investmentId === id);
    if (inputIndex === -1) return;

    const percentIndex = inputRef?.current[id]?.value?.indexOf("%");
    const cursorPos = inputRef?.current[id]?.selectionStart;

    if (cursorPos >= percentIndex) {
      e.preventDefault();
      setTimeout(() => {
        inputRef?.current[id]?.setSelectionRange(percentIndex, percentIndex);
      }, 0);
    }
  };

  const openPopup = (url) => {
    const width = 1200;
    const height = 600;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;
    const popup = window.open(
      cmsConfig.baseUrl + url,
      "PopupWIndow",
      `width=${width},height=${height},left=${left},top=${top}` //eslint-disable-line
    );
    if (popup) {
      popup.focus();
    } else {
      alert("Popup blocked! Please allow popups for this site.");
    }
  };

  const managedForMeTooltip = (
    <Popover id="eac-pop-id" className="eac-popover-inner">
      <Popover.Body className="eac-popover-body">
        <div className="title mb-2">
          <strong>Managed for me</strong>
        </div>
        <div className="sub-title mb-2">
          A range of ready-made investment options designed and managed for you
          by TPT.
        </div>
        <div className="sub-title mb-2">
          This includes the Target Date Funds which would manage your investment
          during your savings period and for up to 30 years beyond the target
          date.
        </div>
        <div className="sub-title mb-3">
          Please review your choice of investments from time to time so that
          they continue to meet your needs and risk appetite.
        </div>
      </Popover.Body>
    </Popover>
  );

  const selfManagedTooltip = (
    <Popover id="eac-pop-id" className="eac-popover-inner">
      <Popover.Body className="eac-popover-body">
        <div className="title mb-2">
          <strong>Self-managed</strong>
        </div>
        <div className="sub-title mb-2">
          A range of investment options that you mix and match yourself.
        </div>
        <div className="sub-title mb-3">
          If you decide that you’d like your savings to grow faster, for
          example, we have funds that expose your money to slightly higher
          levels of risk for a potentially higher return. Or, there are ways to
          invest your pension savings in only ethical funds.
        </div>
        <div className="sub-title mb-3">
          Please review your choice of self-managed funds on a regular basis so
          that they continue to meet your needs and risk appetite.
        </div>
      </Popover.Body>
    </Popover>
  );

  const riskRatingToolTip = (investmentId) => {
    return (
      <Popover id={`pop-id-${investmentId}`} className="eac-popover-inner">
        <Popover.Body className="eac-popover-body">
          <div className="sub-title mb-2">
            It measures the relative risk and reward of an investment fund,
            where 1 being low risk and potentially low returns up to 7 high risk
            and potentially high returns.
          </div>
          <div className="sub-title mb-3">
            It’s calculated using past performance and volatility. This risk
            rating is a ‘Synthetic Risk and Reward Indicator’ (SRRI). The SRRI
            risk ratings are based on European Security and Markets Authority
            (ESMA) guidelines.
          </div>
          <div className="sub-title mb-3">
            The risk rating doesn’t guarantee how the fund will perform in the
            future, and it can change over time.
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  const esgRatingToolTip = (investmentId) => {
    return (
      <Popover id={`pop-id-${investmentId}`} className="eac-popover-inner">
        <Popover.Body className="eac-popover-body">
          <div className="sub-title mb-2">
            The MSCI ESG Fund Rating is designed to measure the Environmental,
            Social and Governance (ESG) characteristics of a fund’s underlying
            investment holdings.
          </div>
          <div className="sub-title mb-3">
            The ESG Rating ranges from leader (AAA, AA), average (A, BBB, BB) to
            laggard (B, CCC).
          </div>
          <div className="sub-title mb-3">
            The overall fund score is based on each individual holding’s ESG
            rating and the proportion held in this fund (and if there is
            sufficient available data to do so).
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  return (
    <div className="horizontal-cards-container">
      {cardsData?.length !== 0 ? (
        <div className="managed-income-heading-saving">
          <span className="manage-heading-text">
            {props.category}{" "}
            <OverlayTrigger
              placement="bottom"
              overlay={
                props.category === "Self-managed"
                  ? selfManagedTooltip
                  : managedForMeTooltip
              }
              flip={true}
            >
              <span className="manage-heading-icon-margin">
                <Icons iconname="tool-tip" variant="icon-sixteen-px" />
              </span>
            </OverlayTrigger>
          </span>
        </div>
      ) : (
        ""
      )}
      {cardsData &&
        cardsData?.map((card) => (
          <ReactCardFlip
            key={card.investmentId}
            isFlipped={isFlipped[card.investmentId] || false}
            flipDirection="horizontal"
          >
            <div className="investment-card" key={`front-${card.investmentId}`}>
              <div className="card-front">
                <div className="fund-name">
                  <span
                    className="circle"
                    style={{ backgroundColor: card.color }}
                  ></span>
                  {card.fundName}
                </div>
                {props.investmentStrategyKey === "futurePaymentsOnly" ? (
                  <div className="empty-div"></div>
                ) : (
                  <>
                    <hr className="upper-line" />
                    <div className="parent-value">
                      <>
                        <span className="current-value-text">Value</span>
                        <span className="current-value">
                          £{addCommas(Math.trunc(card.balance))}.
                          <span className="eac-pot-value-small-digit">
                            {(card.balance % 1).toFixed(2).substring(2)}
                          </span>
                        </span>
                      </>
                    </div>
                    <hr className="lower-line" />
                  </>
                )}
                <div className="fund-text">
                  {card.shortDesc !== undefined ? card.shortDesc : card.desc}
                </div>
                <div className="slider">
                  {card.fundName !== "TPT Money Market Fund" &&
                  card.fundName !== "SIPP TPT Money Market Fund" ? (
                    <Row>
                      <Col xl={10} xs={10} sm={10} lg={10} md={10}>
                        <Slider
                          onChange={(e) =>
                            handleInputChange(card.investmentId, e.target.value)
                          }
                          value={card.fundPercentage}
                          minValue="0"
                          maxValue="100"
                          step="1"
                          className="change-investment-slider"
                        />
                      </Col>
                      <Col
                        xl={2}
                        xs={2}
                        sm={2}
                        lg={2}
                        md={2}
                        className="input-text-col"
                      >
                        <input
                          type="text"
                          ref={(el) =>
                            (inputRef.current[card.investmentId] = el)
                          }
                          className="input-text"
                          value={`${card.fundPercentage}%`}
                          onChange={(e) =>
                            handleInputChange(
                              card.investmentId,
                              e.target.value.replace("%", "") //eslint-disable-line
                            )
                          }
                          onKeyUp={(e) =>
                            handleKeyDown(
                              e,
                              card.investmentId //eslint-disable-line
                            )
                          }
                        />
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xl={10} xs={10} sm={10} lg={10} md={10}></Col>
                      <Col
                        xl={2}
                        xs={2}
                        sm={2}
                        lg={2}
                        md={2}
                        className="blank-input-text-col"
                      ></Col>
                    </Row>
                  )}
                </div>
                <div className="button-align-saving d-none d-xl-block d-lg-block d-md-block">
                  <div className="view-fund-button-saving">
                    <Buttons
                      name="View full fund fact sheet"
                      className="tertiary"
                      handleClick={() =>
                        openPopup(
                          card.mediaUrl !== undefined
                            ? card.mediaUrl
                            : card.pDFUrl //eslint-disable-line
                        )
                      }
                    ></Buttons>
                  </div>
                  <Buttons
                    name="See overview"
                    className="secondary"
                    handleClick={() => handleClick(card.investmentId)}
                  ></Buttons>
                </div>
                <div className="d-block d-sm-none">
                  <div className="fs-mobile-button-align-front">
                    <div className="fs-mobile-view-fund-button-front">
                      <Buttons
                        name="View fund fact sheet"
                        className="tertiary"
                        handleClick={() =>
                          openPopup(
                            card.mediaUrl !== undefined
                              ? card.mediaUrl
                              : card.pDFUrl //eslint-disable-line
                          )
                        }
                      ></Buttons>
                    </div>
                    <div className="fs-mobile-see-overview-button-front">
                      <Buttons
                        name="See overview"
                        className="secondary"
                        handleClick={() => handleClick(card.investmentId)}
                      ></Buttons>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="back-investment-card"
              key={`back-${card.investmentId}`}
            >
              <div className="card-back">
                <div className="fund-name">
                  <span
                    className="circle"
                    style={{ backgroundColor: card.color }}
                  ></span>
                  {card.fundName}
                </div>
                <div>
                  <Row className="managed-by-text">
                    <Col>
                      <div className="managed-parent-text">
                        <span className="left-text">Managed by</span>
                        <span className="right-text">{card.managedBy}</span>
                      </div>
                    </Col>
                  </Row>
                  <Row className="managed-by-text">
                    <Col>
                      <div className="managed-parent-text">
                        <span className="left-text">Fund charge</span>
                        <span className="right-text">{card.fundCharge}</span>
                      </div>
                    </Col>
                  </Row>
                  <Row className="managed-by-text">
                    <Col>
                      <div className="managed-parent-text">
                        <span className="left-text">
                          Risk rating
                          <span
                            className="risk-rating-icon-margin"
                            id={card.investmentId}
                          >
                            <OverlayTrigger
                              id={card.investmentId}
                              placement="bottom"
                              overlay={riskRatingToolTip(card.investmentId)}
                              flip={true}
                            >
                              <span>
                                <Icons
                                  iconname="tool-tip"
                                  variant="icon-sixteen-px"
                                />
                              </span>
                            </OverlayTrigger>
                          </span>
                        </span>
                        <span className="right-text">{card.riskRating}</span>
                      </div>
                    </Col>
                  </Row>
                </div>
                {card.ESGRating === "" ||
                card.ESGRating === " " ||
                card.ESGRating === null ? (
                  <>
                    <div className="parent-rating-box-blank"></div>
                  </>
                ) : (
                  <>
                    <div className="Average-text">
                      Average ESG Rating{" "}
                      <span
                        className="risk-rating-icon-margin"
                        id={card.investmentId}
                      >
                        <OverlayTrigger
                          id={card.investmentId}
                          placement="bottom"
                          overlay={esgRatingToolTip(card.investmentId)}
                          flip={true}
                        >
                          <span>
                            <Icons
                              iconname="tool-tip"
                              variant="icon-sixteen-px"
                            />
                          </span>
                        </OverlayTrigger>
                      </span>
                    </div>
                    <div className="parent-rating-box">
                      <span
                        className={
                          card.ESGRating === "CCC"
                            ? "colored-rating-box"
                            : "rating-box"
                        }
                      >
                        CCC
                      </span>
                      <span
                        className={
                          card.ESGRating === "B"
                            ? "colored-rating-box"
                            : "rating-box"
                        }
                      >
                        B
                      </span>
                      <span
                        className={
                          card.ESGRating === "BB"
                            ? "colored-rating-box"
                            : "rating-box"
                        }
                      >
                        BB
                      </span>
                      <span
                        className={
                          card.ESGRating === "BBB"
                            ? "colored-rating-box"
                            : "rating-box"
                        }
                      >
                        BBB
                      </span>
                      <span
                        className={
                          card.ESGRating === "A"
                            ? "colored-rating-box"
                            : "rating-box"
                        }
                      >
                        A
                      </span>
                      <span
                        className={
                          card.ESGRating === "AA"
                            ? "colored-rating-box"
                            : "rating-box"
                        }
                      >
                        AA
                      </span>
                      <span
                        className={
                          card.ESGRating === "AAA"
                            ? "colored-rating-box"
                            : "rating-box"
                        }
                      >
                        AAA
                      </span>
                    </div>
                  </>
                )}
                <div className="button-align-saving d-none d-xl-block d-lg-block d-md-block">
                  <div className="view-fund-button-saving">
                    <Buttons
                      name="View full fund fact sheet"
                      className="tertiary"
                      handleClick={() =>
                        openPopup(
                          card.mediaUrl !== undefined
                            ? card.mediaUrl
                            : card.pDFUrl //eslint-disable-line
                        )
                      }
                    ></Buttons>
                  </div>
                  <Buttons
                    name="Close overview"
                    className="secondary"
                    handleClick={() => handleClick(card.investmentId)}
                  ></Buttons>
                </div>
                <div className="back-main-footer d-block d-sm-none">
                  <div className="fs-mobile-button-align-back">
                    <div className="fs-mobile-view-fund-button-back">
                      <Buttons
                        name="View fund fact sheet"
                        className="tertiary"
                        handleClick={() =>
                          openPopup(
                            card.mediaUrl !== undefined
                              ? card.mediaUrl
                              : card.pDFUrl //eslint-disable-line
                          )
                        }
                      ></Buttons>
                    </div>
                    <div className="fs-mobile-see-overview-button-back">
                      <Buttons
                        name="See overview"
                        className="secondary"
                        handleClick={() => handleClick(card.investmentId)}
                      ></Buttons>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ReactCardFlip>
        ))}
    </div>
  );
};

export default ExploreAndChangeInvestment;
